/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
import { sha256 } from 'js-sha256';

export const hash256 = (value: string) => {
  return sha256(value);
};
